/**
 * Remoção de qualquer campo sensível antes de gravar no arquivo de backup.
 * Regra: nada de segredo, token, senha, chave ou referência de credencial sai do banco.
 */

export const SECRET_KEY_PATTERN =
  /(secret|token|password|passwd|api[_-]?key|apikey|access[_-]?key|private[_-]?key|credential|authorization|bearer|session[_-]?key|refresh)/i;

/** Colunas mantidas para integration_settings (nunca o segredo). */
export const INTEGRATION_SETTINGS_ALLOWLIST = [
  "id",
  "owner_id",
  "provider",
  "status",
  "public_config",
  "last_checked_at",
  "last_success_at",
  "created_at",
  "updated_at",
];

export function isSecretKey(key: string): boolean {
  return SECRET_KEY_PATTERN.test(key);
}

/** Remove recursivamente chaves sensíveis, inclusive dentro de arrays/JSONB. */
export function sanitizeValue(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(sanitizeValue);
  if (!value || typeof value !== "object") return value;
  const out: Record<string, unknown> = {};
  for (const [key, nested] of Object.entries(value as Record<string, unknown>)) {
    if (isSecretKey(key) || key === "__proto__" || key === "prototype" || key === "constructor") continue;
    out[key] = sanitizeValue(nested);
  }
  return out;
}

export function sanitizeRow<T extends Record<string, any>>(row: T): Record<string, any> {
  return sanitizeValue(row) as Record<string, any>;
}

export function sanitizeRows(table: string, rows: Record<string, any>[]): Record<string, any>[] {
  if (table === "integration_settings") {
    return rows.map((row) => {
      const picked: Record<string, any> = {};
      for (const col of INTEGRATION_SETTINGS_ALLOWLIST) if (col in row) picked[col] = row[col];
      return sanitizeRow(picked);
    });
  }
  return rows.map(sanitizeRow);
}
